import PropTypes from 'prop-types';
import { useMemo } from 'react';
// @mui
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import customShadows from '../../theme/customShadows';
import componentsOverride from '../../theme/overrides';
import palette from '../../theme/palette';
import shadows from '../../theme/shadows';
import typography from '../../theme/typography';

// ----------------------------------------------------------------------

PublicPageTheme.propTypes = {
  children: PropTypes.node,
};

export default function PublicPageTheme({ children }) {
  const outerTheme = useTheme();

  const theme = useMemo(() => {
    const themeOptions = {
      palette: palette('light'),
      typography,
      shape: { borderRadius: 8 },
      direction: outerTheme.direction,
      shadows: shadows('light'),
      customShadows: customShadows('light'),
    };
    const nextTheme = createTheme(themeOptions);
    nextTheme.components = componentsOverride(nextTheme);
    return nextTheme;
  }, [outerTheme.direction]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
